/**
 * SIDC E-Collect Core
 * Our Endpoints are powered by .Net Core, Onion Architecture, CQRS with MediatR Library,Entity Framework Core - Code First,Repository Pattern - Generic, Swagger UI, API Versioning,Fluent Validation and Automapper.
 *
 * OpenAPI spec version: v1
 * Contact: sidcmisdepartment@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BulkUpSertLoanDetailsDTO { 
    memberCode?: string;
    loanTypeId?: string;
    branchId?: string;
    interest?: string;
    penalties?: string;
    serviceFee?: string;
    miscellaneousIncome?: string;
    collectorUserName?: string;
    releasedAmount?: string;
    releasedDate?: string;
    maturityDate?: string;
    dateEndorsed?: string;
    daysTurnOver?: string;
    loanDetailsStatusId?: string;
    statusNumberOfDays?: string;
    outstandingPrincipalBalance?: string;
    unpaidPrincipal?: string;
    collectionFee?: string;
    litigationFee?: string;
    totalBalance?: string;
    forwardingAccountsId?: string;
}